import axios from "axios"

const initializeApp = () => {
    // Leave the axios base URL relative so API calls always go to the origin the
    // app is currently served from. The app is served on more than one hostname
    // (e.g. truenorth-staging.caselmedical.com and link-staging.truenethealth.com)
    // and the /createSessionLogin rewrite must be same-origin, otherwise the
    // __session cookie is set on the wrong domain and login silently fails.
    // REACT_APP_BASE_URL is only honoured when explicitly pointing elsewhere
    // (local emulator work), never in a deployed build.
    if (process.env.NODE_ENV === 'development' && process.env.REACT_APP_BASE_URL) {
        axios.defaults.baseURL = process.env.REACT_APP_BASE_URL
    }


    if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
        // dev code

    } else {
        // Prod build code
        // Removing console.log from prod
        // console.log = () => {};
        // init analytics here
    }
}

export default initializeApp